export default __webpack_public_path__ + "static/media/pdf-icon.6080096b.svg";